<!--
 * @Author:
 * @LastEditTime: 2022-04-18 17:10:30
 * @Description: 新增、编辑用户
-->
<template>
  <div>
    <el-dialog
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="userProps.visible"
      :title="userProps.title"
      class="small-dialog"
    >
      <el-form
        :model="userForm"
        :rules="userFormRules"
        ref="userForm"
        label-width="150px"
        :disabled="userProps.editType === 'read'"
      >
        <el-form-item label="登录名称" prop="userName">
          <el-input v-model="userForm.userName" size="small" clearable />
        </el-form-item>
        <el-form-item label="用户邮箱" prop="email">
          <el-input v-model="userForm.email" size="small" clearable />
        </el-form-item>
        <el-form-item label="用户密码" prop="password" v-if="userProps.editType === 'create'">
          <el-input v-model="userForm.password" type="password" size="small" clearable />
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="confirmPassword"
          v-if="userProps.editType === 'create'"
        >
          <el-input v-model="userForm.confirmPassword" type="password" size="small" clearable />
        </el-form-item>

        <el-form-item label="启用锁定" prop="lockoutEnabled">
          <el-checkbox v-model="userForm.lockoutEnabled" />
        </el-form-item>
        <el-form-item label="启用" prop="isActive">
          <el-checkbox v-model="userForm.isActive" />
        </el-form-item>
        <el-form-item label="姓" prop="surname">
          <el-input v-model="userForm.surname" size="small" clearable />
        </el-form-item>
        <el-form-item label="名字" prop="name">
          <el-input v-model="userForm.name" size="small" clearable />
        </el-form-item>
        <el-form-item label="电话" prop="phoneNumber">
          <el-input v-model="userForm.phoneNumber" size="small" clearable />
        </el-form-item>
        <el-form-item label="角色" prop="roleNames">
          <el-select size="small" v-model="userForm.roleNames" filterable class="w-full" multiple>
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center" v-if="userProps.editType !== 'read'">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { UserApi, RoleApi } from '@wiz-api/abp-identity'

const roleApi = new RoleApi()
const userApi = new UserApi()

export default {
  name: 'operateUserDialog',
  props: {
    userProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '新增用户',
          editType: 'create',
        }
      },
    },
    userForm: {
      type: Object,
      default: () => {
        return {
          userName: '',
          surname: '',
          confirmPassword: '',
          name: '',
          password: '',
          email: '',
          phoneNumber: '',
          roleNames: [],
          lockoutEnabled: false,
          isActive: false,
        }
      },
    },
  },
  watch: {
    userProps: {
      deep: true,
      immediate: true,
      handler(props) {
        if (!props.visible) {
          return
        }
        this.$nextTick(() => {
          this.$refs.userForm.clearValidate()
        })
        if (props.editType !== 'create') {
          this.getUserRoles()
          return
        }
        // 新增时候将默认角色带出来
        if (props.editType === 'create') {
          setTimeout(() => {
            this.userForm.roleNames = _.map(_.filter(this.roles, 'isDefault'), 'name')
          }, 500)
        }
      },
    },
  },
  data() {
    const validataPassword = (rule, value, callback) => {
      if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9])(?=.*\d)[\s\S]{6,}$/.test(value) === false) {
        callback(new Error('密码至少6位，且包含数字、大小写字母和特殊字符'))
        return
      }
      callback()
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请再次输入密码'))
      }
      if (value !== this.userForm.password) {
        return callback(new Error('两次输入密码不一致!'))
      }
      return callback()
    }
    return {
      userFormRules: {
        userName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            validator: validataPassword,
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            validator: validateConfirmPassword,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
      },
      roles: [],
    }
  },
  methods: {
    async getUserRoles() {
      const [err, res] = await userApi.getRoles(this.userForm.id)
      if (!err) {
        this.userForm.roleNames = _.map(res.items, (item) => {
          return item.name
        })
      }
    },
    async getAllRole() {
      const [err, res] = await roleApi.getAllList()
      if (!err) {
        this.roles = res.items
      }
    },
    save() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          if (this.userProps.editType === 'create') {
            const [err] = await userApi.create({
              body: this.userForm,
            })
            if (!err) {
              this.$message.success('新增用户成功')
              this.userProps.visible = false
              this.$emit('refreshList')
            }
            return
          }
          const [err] = await userApi.update(this.userForm.id, {
            body: this.userForm,
          })
          if (!err) {
            this.$message.success('修改用户成功')
            this.userProps.visible = false
            this.$emit('refreshList')
          }
        }
      })
    },
    cancel() {
      this.userProps.visible = false
    },
  },
  created() {
    this.getAllRole()
  },
}
</script>
